import { toast } from 'react-toastify';

/**
 * Toast notification utility
 * Provides consistent toast notifications across the app
 */

const toastConfig = {
  position: 'top-right',
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const showToast = {
  /**
   * Show success toast
   * @param {string} message - Success message
   * @param {Object} options - Additional toast options
   */
  success: (message, options = {}) => {
    toast.success(message, {
      ...toastConfig,
      ...options,
    });
  },

  /**
   * Show error toast
   * @param {string} message - Error message
   * @param {Object} options - Additional toast options
   */
  error: (message, options = {}) => {
    toast.error(message, {
      ...toastConfig,
      autoClose: 5000, // Keep errors visible longer
      ...options,
    });
  },

  /**
   * Show info toast
   * @param {string} message - Info message
   * @param {Object} options - Additional toast options
   */
  info: (message, options = {}) => {
    toast.info(message, {
      ...toastConfig,
      ...options,
    });
  },

  /**
   * Show warning toast
   * @param {string} message - Warning message
   * @param {Object} options - Additional toast options
   */
  warning: (message, options = {}) => {
    toast.warning(message, {
      ...toastConfig,
      ...options,
    });
  },

  /**
   * Show loading toast
   * @param {string} message - Loading message
   * @returns {number|string} Toast ID
   */
  loading: (message) => {
    return toast.loading(message, toastConfig);
  },

  /**
   * Update existing toast
   * @param {number|string} toastId - Toast ID
   * @param {Object} options - Update options
   */
  update: (toastId, options) => {
    toast.update(toastId, {
      ...toastConfig,
      ...options,
      isLoading: false,
    });
  },

  /**
   * Dismiss toast
   * @param {number|string} toastId - Toast ID (optional, dismisses all if not provided)
   */
  dismiss: (toastId) => {
    if (toastId) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  },
};

export default showToast;

